module.exports = __webpack_public_path__ + "static/media/dashboard.bf3cb650.png";